import { render, staticRenderFns } from "./Demonstracao.vue?vue&type=template&id=528135a7"
import script from "./Demonstracao.vue?vue&type=script&lang=js"
export * from "./Demonstracao.vue?vue&type=script&lang=js"
import style0 from "./Demonstracao.vue?vue&type=style&index=0&id=528135a7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports